import { documentId, getDocs, query, QuerySnapshot, where } from 'firebase/firestore';
import _ from 'lodash';
import { Collections, QuestionSetOperations } from '../data/Firestore';
import { QuestionConfig, QuestionSet, QuestionSetConfig, QuestionSetId } from '../types/GameplayTypes';
import { QuestionProvider } from './QuestionProvider';

/** Question provider that loads questions from Firestore. */
export class FirestoreQuestionProvider extends QuestionProvider {

	protected async questionData(questionSetId?: QuestionSetId): Promise<QuestionSet> {
		const setId = questionSetId ?? 'qset1';

		const config = await QuestionSetOperations.get(setId);

		if (!config.isActive) {
			throw new Error(`Question set "${setId}" is not active`);
		}

		const questionsSnapshot = await this.fetchQuestions(config, setId);

		return {
			..._.omit(config, 'questionIds'),
			questions: this.sortQuestionsSnapshot(questionsSnapshot, config)
		};
	}

	/** Fetch only the questions in this set */
	private async fetchQuestions(config: QuestionSetConfig, setId: string) {
		const questionsQuery = query(Collections.questions,
			where(documentId(), 'in', config.questionIds)
		);
		const questionsSnapshot = await getDocs(questionsQuery);

		if (questionsSnapshot.empty) {
			throw new Error(`No questions found for Question Set "${setId}"`);
		}
		return questionsSnapshot;
	}

	private sortQuestionsSnapshot(snapshot: QuerySnapshot<QuestionConfig>, config: QuestionSetConfig): QuestionConfig[] {
		const unordered = snapshot.docs.map(doc => doc.data());
		return config.questionIds
			.map(id => unordered.find(q => q.id === id))
			.filter(q => q !== undefined);
	}
}